import {
  AfterViewInit,
  Component,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomPage } from "src/app/models/custom-page-model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DefaultService } from "src/app/services/default/default.service";
import { CustomTable } from "src/app/models/custom-table-model";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomFile } from "src/app/models/custom-file-model";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CustomActions } from "src/app/utils/custom-actions";
import { CustomService } from "src/app/services/custom/custom.service";

import intlTelInput from "intl-tel-input";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";

import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { Address } from "ngx-google-places-autocomplete/objects/address";

@Component({
  selector: "app-default-add",
  templateUrl: "./default-add.component.html",
  styleUrls: ["./default-add.component.scss"],
})
export class DefaultAddComponent implements OnInit, AfterViewInit {
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;

  public Editor = ClassicEditor;

  file!: File;
  image: any;
  submitted: boolean = false;
  endpoint: string = "";
  title: string = "";
  model: any;
  form!: FormGroup;
  inputs: Array<any> = [];
  inputs_file: Array<any> = [];
  custom_files: Array<CustomFile> = [];
  relations_image: any = {};
  section_gallery: Array<any> = [];
  relations_select: Array<any> = [];
  relations_multi_check: Array<any> = [];
  query_params: any = {};

  phoneInputElement!: any;

  constructor(
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private defaultService: DefaultService,
    private router: Router,
    private location: Location,
    private customService: CustomService,
    private zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    const inputElement = document.getElementById("phone");
    if (inputElement) {
      this.phoneInputElement = intlTelInput(inputElement as HTMLInputElement, {
        initialCountry: "FR",
        separateDialCode: true,
      });
    }
    Webflow.setIFrameHeight();
  }

  get form_controls() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((route) => {
      this.spinner.show();
      this.endpoint = route.endpoint;
      let form_datas = CustomPage.get_form_datas(this.endpoint);
      this.title = form_datas.title;
      this.model = form_datas.model;
      this.inputs = form_datas.inputs.filter((element: any) => {
        return element.type != "file" && element.type != "galeries";
      });
      this.inputs_file = form_datas.inputs.filter((element: any) => {
        return element.type == "file";
      });
      this.custom_files = [];
      this.inputs_file.forEach((element) => {
        let custom_file: CustomFile = new CustomFile();
        custom_file.name = element.name;
        this.custom_files.push(custom_file);
      });
      this.relations_image = form_datas.relations.find((element: any) => {
        return element.component == "image";
      });
      this.form = this.formBuilder.group(form_datas.form_builder);
      this.relations_select = form_datas.relations.filter((element: any) => {
        return (
          element.component == "select" || element.component == "autocomplete"
        );
      });

      this.relations_multi_check = form_datas.relations.filter(
        (element: any) => {
          return element.component == "multi-check";
        }
      );

      this.section_gallery = form_datas.inputs.filter((element: any) => {
        return element.type == "galeries";
      });

      this.generate_relations_datas();
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.query_params = params;
      this.image = environment.default_cover;
    });
  }

  selectEvent($event, element: any) {
    let data = this.relations_select.find((item) => {
      return item.name == element.name;
    });
    if (data) {
      data.selected = $event.id;
    }
  }

  onCleared(element: any) {
    let data = this.relations_select.find((item) => {
      return item.name == element.name;
    });
    if (data) {
      data.selected = null;
    }
  }

  async onSubmit() {
    this.submitted = true;
    this.spinner.show();

    let object = this.form.value;

    this.inputs
      .filter((element) => {
        return element.type == "date";
      })
      .forEach((item) => {
        if (object[item.name] != "") {
          object[item.name] =
            object[item.name].year +
            "-" +
            (object[item.name].month.toString().length == 1
              ? "0" + object[item.name].month.toString()
              : object[item.name].month) +
            "-" +
            (object[item.name].day.toString().length == 1
              ? "0" + object[item.name].day.toString()
              : object[item.name].day);
        }
      });

    this.inputs
      .filter((element) => {
        return element.type == "datetime";
      })
      .forEach((item) => {
        if (
          object[item.name] != "" &&
          object[item.name] != "" &&
          object[item.name] != null
        ) {
          var mydate = new Date(object[item.name]);
          object[item.name] = this.formatDateTime(mydate);
        } else {
          object[item.name] = null;
        }
      });

    console.log(this.relations_multi_check);

    this.relations_multi_check
      .filter((element) => {
        return element.component == "multi-check";
      })
      .forEach((item) => {
        object[item.name] = item.selected_array;
      });

    var inputPhoneIndex = this.inputs.findIndex((element) => {
      return element.type == "phone";
    });

    if (inputPhoneIndex != -1) {
      if (
        this.inputs[inputPhoneIndex].field_country != "" &&
        this.inputs[inputPhoneIndex].field_country != null &&
        this.inputs[inputPhoneIndex].field_country != undefined &&
        this.inputs[inputPhoneIndex].field_code != "" &&
        this.inputs[inputPhoneIndex].field_code != null &&
        this.inputs[inputPhoneIndex].field_code != undefined
      ) {
        if (
          object[this.inputs[inputPhoneIndex].name] != "" &&
          object[this.inputs[inputPhoneIndex].name] != null
        ) {
          const countryData = this.phoneInputElement.getSelectedCountryData();
          object[this.inputs[inputPhoneIndex].name] = object[
            this.inputs[inputPhoneIndex].name
          ].replace(/\s+/g, "");
          object[this.inputs[inputPhoneIndex].field_country] = countryData.iso2;
          object[this.inputs[inputPhoneIndex].field_code] =
            "+" + countryData.dialCode;
        } else {
          object[this.inputs[inputPhoneIndex].name] = "";
          object[this.inputs[inputPhoneIndex].field_country] = "";
          object[this.inputs[inputPhoneIndex].field_code] = "";
        }
      } else {
        Swal.fire({
          title: "Erreur",
          text: "Veuillez définir les paramètres field_country et field_code dans votre modèle pour le champ de type téléphone",
          icon: "error",
          position: "top",
        });
        this.spinner.hide();
        return;
      }
    }

    this.form.setValue(object);

    let custom_submit_value = await new CustomActions(
      null,
      this.router,
      this.spinner,
      this.customService
    ).custom_add_submit(this.endpoint, this.form, this.inputs, this.spinner);

    if (custom_submit_value) {
      this.submitted = false;
    } else {
      // default submit
      if (this.inputs.length > 0 || this.inputs_file.length > 0) {
        if (this.form.invalid) {
          Swal.fire({
            title: "Erreur",
            text: "Veuillez saisir les champs vides",
            icon: "error",
            position: "top",
          });
          this.spinner.hide();
          return;
        }

        let file_name = "";
        if (this.relations_image) {
          file_name = this.relations_image.name;
        }

        if (file_name != "" && this.file == null) {
          Swal.fire({
            title: "Erreur",
            text: "Veuillez uploader une image",
            icon: "error",
            position: "top",
          });
          this.spinner.hide();
          return;
        } else if (file_name != "" && this.file != null) {
          let customFile: CustomFile = new CustomFile();
          customFile.name = file_name;
          customFile.file = this.file;
          this.custom_files.push(customFile);
        }

        if (
          this.custom_files.length > 0 &&
          this.custom_files.filter((element: CustomFile) => {
            return element.file == null;
          }).length > 0
        ) {
          Swal.fire({
            title: "Erreur",
            text: "Veuillez uploader les fichiers",
            icon: "error",
            position: "top",
          });
          this.spinner.hide();
          return;
        }

        this.section_gallery.forEach((element: any) => {
          element.files.forEach((itemFile) => {
            let customFile: CustomFile = new CustomFile();
            customFile.name = element.name;
            customFile.file = itemFile;

            this.custom_files.push(customFile);
          });
        });

        let relations_selection_empty = this.relations_select.filter(
          (element: any) => {
            return element.required && element.selected == null;
          }
        );
        if (relations_selection_empty.length > 0) {
          let str = "";
          relations_selection_empty.forEach((item: any) => {
            str += " - " + item.label;
          });
          Swal.fire({
            title: "Erreur",
            text: "Veuillez séléctionner : " + str,
            icon: "error",
            position: "top",
          });
          this.spinner.hide();
          return;
        }

        this.relations_select.forEach(async (item: any) => {
          object[item.name] = item.selected;
        });

        Object.entries(this.query_params).forEach(([key, value], index) => {
          object[key] = value;
        });

        this.defaultService
          .create(this.endpoint, object, this.custom_files)
          .subscribe(
            (res) => {
              Swal.fire({
                title: "Félicitation",
                text: "Ajout effectué avec succés",
                icon: "success",
                position: "top",
              });
              this.form.reset();
              this.location.back();
            },
            (err) => {
              if (
                err.error.details != undefined &&
                err.error.details.message != undefined
              ) {
                Swal.fire({
                  title: "Erreur",
                  text: err.error.details.message,
                  icon: "error",
                  position: "top",
                });
              } else {
                this.errors(err);
              }
            }
          )
          .add(() => {
            this.spinner.hide();
            this.submitted = false;
          });
      }
    }
  }

  clear() {
    this.form.reset();
    this.image = environment.default_cover;
    this.file = null;
  }

  back() {
    this.location.back();
  }

  generate_relations_datas(more_filter?: string) {
    this.relations_select.forEach(async (item: any) => {
      let filters = item.filters !== undefined ? item.filters : "";

      filters +=
        more_filter != null && more_filter != undefined ? more_filter : "";

      item.array = await this.select_datas(item.endpoint, filters)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return [];
        });
      item.selected = null;
    });

    this.generate_data_multi_check();
    this.spinner.hide();
  }

  generate_data_multi_check() {
    this.relations_multi_check.forEach(async (item: any) => {
      let filters = item.filters;

      if (item.where_filter_field != "") {
        if (
          this.form.value[item.where_filter_field] != null &&
          this.form.value[item.where_filter_field] != undefined
        ) {
          filters = filters.replace(
            "{where_filter_field}",
            this.form.value[item.where_filter_field]
          );

          item.init_array = await this.select_datas(item.endpoint, filters)
            .then((res) => {
              return res;
            })
            .catch((err) => {
              return [];
            });
        }
      } else {
        item.init_array = await this.select_datas(item.endpoint, filters)
          .then((res) => {
            return res;
          })
          .catch((err) => {
            return [];
          });
      }
    });
  }

  async onSelectedChange(element: any) {
    var selected_multi_check = this.relations_multi_check.find((item: any) => {
      return item.where_filter_field == element.name;
    });

    if (selected_multi_check) {
      let filters = selected_multi_check.filters;

      if (
        this.form.value[selected_multi_check.where_filter_field] != null &&
        this.form.value[selected_multi_check.where_filter_field] != undefined
      ) {
        filters = filters.replace(
          "{where_filter_field}",
          this.form.value[selected_multi_check.where_filter_field]
        );

        selected_multi_check.init_array = await this.select_datas(
          selected_multi_check.endpoint,
          filters
        )
          .then((res) => {
            return res;
          })
          .catch((err) => {
            return [];
          });
      }
    }
  }

  async onChangeCheckBox(element: any, item_multi_check: any) {
    let found_index = element.selected_array.findIndex(
      (item: any) => item == item_multi_check.title
    );
    if (found_index == -1) {
      element.selected_array.push(item_multi_check.title);
    } else {
      element.selected_array.splice(found_index, 1);
    }
  }

  async select_datas(endpoint: string, filters: string) {
    var mypromise = new Promise((resolve, reject) => {
      this.defaultService.get(endpoint + filters).subscribe(
        (res) => {
          let customTable = new CustomTable(endpoint);
          resolve(customTable.get_array_data(res.data));
        },
        (err) => {
          reject([]);
        }
      );
    });
    return mypromise;
  }

  onInputChange(event: any, element: any) {
    if (element.endpoint == "formations") {
      this.generate_relations_datas(
        "&filters[title][$contains]=" + event.target.value
      );
    }
  }

  uploadInputsFile(name: string, event: any) {
    if (
      this.custom_files.find((custom_file: any) => {
        return custom_file.name == name;
      })
    ) {
      this.custom_files.find((custom_file: any) => {
        return custom_file.name == name;
      }).file = event.target.files[0];
    }
  }

  uploadFile(event: any) {
    var reader = new FileReader();
    this.file = event.target.files[0];
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = () => {
      if (img.width < 200 || img.height < 200) {
        Swal.fire({
          title: "Erreur",
          text: "L'image téléchargée est trop petite. La taille d'image minimale est 200x200px. Veuillez télécharger une image plus grande",
          icon: "error",
          position: "top",
        });
        return;
      } else {
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.image = reader.result;
        };
      }
    };
  }

  get_option(element: any, index: any) {
    let text = "";
    if (index instanceof Array) {
      (index as Array<string>).forEach((item) => {
        text += " " + element[item];
      });
    } else {
      text = element[index];
    }
    return text;
  }

  selected_option(event: any, item: any) {
    this.relations_select.forEach(async (element: any) => {
      if (element.name == item) {
        element.selected = event.target.value;
      }
    });
  }

  setBorderInput(item: any) {
    let styles = {
      border:
        this.form_controls[item].errors && this.submitted
          ? "1px solid red"
          : "0px solid white",
    };
    return styles;
  }

  errors(error: any) {
    if (GenerateErrors.check_if_is_custom_error(error)) {
      Swal.fire({
        title: "Erreur",
        text: GenerateErrors.get_message_error(error),
        icon: "error",
        position: "top",
      });
    } else {
      Swal.fire({
        title: "Erreur",
        text: "Erreur de connexion",
        icon: "error",
        position: "top",
      });
    }
  }

  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  generate_ai_description(item: any) {
    let description = this.form_controls[item.name].value;
    if (description.length > 0) {
      this.spinner.show();
      this.customService
        .generate_description_chatgpt(item.route, description)
        .subscribe(
          (res) => {
            if (typeof res === "object") {
              if (res["error"].code == "context_length_exceeded") {
                Swal.fire({
                  title: "Attention",
                  text: "Veuillez réduire le nombre de caractères dans votre message \n ( nombre maximum est 8000 )",
                  icon: "info",
                  position: "top",
                });
              } else {
                let msg = res["error"]?.message;
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Une érreur est survenue",
                  footer: `<p class="alert alert-danger">${msg}</p>`,
                  position: "top",
                });
              }
            } else {
              this.form_controls[item.name].setValue(res);
            }
          },
          (err) => {
            if (err.status === 200) {
              this.form_controls[item.name].setValue(err.error.text);
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Une érreur est survenue",
                footer: `<p class="alert alert-danger">${JSON.stringify(
                  err.error
                )}</p>`,
                position: "top",
              });
            }
          }
        )
        .add(() => {
          this.spinner.hide();
        });
    } else {
      Swal.fire({
        title: "Attention",
        text: "Veuillez saisir une description",
        icon: "info",
        position: "top",
      });
    }
  }

  init_ai_description(item: any) {
    this.form_controls[item.name].setValue("");
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }

  handleAddressChange(place: Address) {
    // Extract latitude and longitude
    const latitude = place.geometry.location.lat();
    const longitude = place.geometry.location.lng();

    console.log(latitude + "  -  " + longitude);

    let city: string = "";
    let country: string = "";
    let short_address: string = "";
    let postal_code: string = "";
    let departement: string = "";

    place.address_components.filter((component: any) => {
      switch (component.types[0]) {
        case "locality":
          city = component.long_name;
          return true;
        case "postal_code":
          postal_code = component.long_name;
          return true;
        case "street_number":
          short_address = short_address + component.long_name;
          return true;
        case "route":
          short_address = short_address + " " + component.long_name;
          return true;
        case "country":
          country = component.long_name;
          return true;
        case "administrative_area_level_2":
          departement = component.long_name;
          return true;
        default:
          return false;
      }
    });
    this.form.controls?.full_address?.setValue(place.formatted_address);
    this.form.controls?.city?.setValue(city);
    this.form.controls?.country?.setValue(country);
    this.form.controls?.address?.setValue(short_address);
    this.form.controls?.postal_code?.setValue(postal_code.toString());
    this.form.controls?.departement?.setValue(departement);
    this.form.controls?.lat?.setValue(latitude.toString());
    this.form.controls?.lng?.setValue(longitude.toString());
  }

  uploadGalleryFile(event, itemGallery: any) {
    var reader = new FileReader();
    itemGallery.files.push(event.target.files[0]);
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      itemGallery.images.push(reader.result);
    };
  }

  removeImage(index: number, itemGallery: any) {
    Swal.fire({
      text: "Voulez-vous supprimer cette photo ?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Supprimer`,
      cancelButtonText: `Annuler`,
      cancelButtonColor: "black",
      confirmButtonColor: "#D63333",
      position: "top",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        itemGallery.files.splice(index, 1);
        itemGallery.images.splice(index, 1);

        Swal.fire({
          title: "Félicitation",
          text: "Supression effectuée avec succès",
          icon: "success",
          position: "top",
        });
      }
    });
  }
}
